
import React, { PureComponent } from 'react';

import Request from "../../networkReq/request";
import Http from "../../networkReq/http"
import { Base64 } from 'js-base64';
import {getUrlParam ,createUUID} from '../../utils/methods'
import { getRecord, setRecord, setClickInfo, getClickInfo } from '../../utils/storage';

import md5 from 'js-md5';
import {
    setToken,
    setCurrentUser,
    setUserId,
    setCaptchaKey,
    removeAll
} from 'utils/storage';
export default class logout extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
        };

    }
    componentDidMount() {
        /**
         * 1、判断是够从第三方应用跳转过来
         */

        let clickInfo={
            //应用key
            clientId:"",
            //回传参数
            goto:"",
        }

        //判断是否是对接系统跳转过来
        let urlparam=this.props.location.search;
        if (urlparam&&getUrlParam("client_id",urlparam)) {
            clickInfo.clientId =getUrlParam("client_id",urlparam);
            clickInfo.goto =getUrlParam("goto",urlparam);
            clickInfo.utype =getUrlParam("utype",urlparam);
            clickInfo.action =getUrlParam("action",urlparam);
            clickInfo.terminaltype =getUrlParam("terminaltype",urlparam);
            /*
            1、判断用户是否以及在一体化门户登录
            2、1）如果一体化门户没有登录、则把client_id 和goto信息保存到页面缓存、再跳转到政务网、
               2）政务网登录后、信息回传到一体化门户、首先一体化门户做自动登录、再把数据post、get 把数据给到第三方应用
            3、如果一体化门户登录、整一体化门户把数据直接post过去
            */
            // setClickInfo(clickInfo);
        }
        console.log("=========退出============");
        let record = getRecord();
        if(record&&record.uuid){
            Http.getApplication(Request.logout(),{sessionid:record.uuid})
        }else{
            Http.getApplication(Request.logout(),{},()=>{})
        }

        let{zwwcom,zwwlogout,clientId,logouttourl}=Request.getZwwConfig();
     
        removeAll();
        var resulturl ='';
        if(clickInfo.goto){
            resulturl=zwwcom+zwwlogout+"?utype=0&goto="+clickInfo.goto+"&client_id="+clientId;
        }else{
            resulturl=zwwcom+zwwlogout+"?utype=0&goto="+logouttourl+"&client_id="+clientId ;
        }
        console.log("退出地址："+resulturl);
        window.location=resulturl;
   
    }
  
    render() {
        return null;
    }
}